import { plannerService } from '@/services'

export default {
  state: () => ({
    allEvents: [],
    events: [],
    upcoming: {
      events: [],
      count: 0
    },
    tags: []
  }),

  mutations: {
    setAllEvents (state, value) {
      state.allEvents = value
    },

    setEvents (state, value) {
      state.events = value
    },

    setTags (state, value) {
      state.tags = value
    },

    addEvent (state, value) {
      const events = state.events
      events.push(value)
      state.events = events
    },

    addToAllEvents (state, value) {
      const allEvents = state.allEvents
      allEvents.push(value)
      state.allEvents = allEvents
    },

    toggleEventTag (state, { tag, eventId, isSelected }) {
      const eventEntity = state.events.find(item => item.event.id === eventId)

      let tags = eventEntity.event.eventTags

      if (isSelected) {
        tags = tags.filter(t => t.id !== tag.id)
      } else {
        tags.push(tag)
      }

      const events = state.events.map(item => {
        if (item.event.id === eventId) {
          return {
            ...item,
            event: {
              ...item.event,
              eventTags: tags
            }
          }
        }
        return item
      })

      state.events = events
    },

    updateEventTag (state, { name, id }) {
      state.tags = state.tags.map(tag => {
        if (tag.id === id) {
          return {
            ...tag,
            name: name
          }
        }
        return tag
      })
    },

    setUpcomingEvents (state, value) {
      state.upcoming = value
    },

    updateEvent (state, value) {
      const events = state.events.map(item => {
        if (item.id === value.id) {
          return {
            ...item,
            ...value
          }
        }
        return item
      })

      const allEvents = state.allEvents.map(item => {
        if (item.id === value.id) {
          return {
            ...item,
            ...value
          }
        }
        return item
      })

      state.events = events
      state.allEvents = allEvents
    },

    deleteEvent (state, id) {
      const events = state.events.filter(item => item.id !== id)
      const allEvents = state.allEvents.filter(item => item.id !== id)

      state.events = events
      state.allEvents = allEvents
    }
  },

  actions: {
    getAllEvents ({ commit }, bookIds) {
      return plannerService.getAll(bookIds)
        .then(({ data }) => {
          commit('setAllEvents', data.events)
        })
    },

    getEventsByDate ({ commit }, { startDate, finishDate, tagIds, bookIds }) {
      return plannerService.getEventsByDate({ startDate, finishDate, tagIds, bookIds })
        .then(({ data }) => {
          commit('setEvents', data.events)
        })
    },

    getEventTags ({ commit }, bookIds) {
      plannerService.getEventTags(bookIds)
        .then(({ data }) => {
          commit('setTags', data.tags)
        })
    },

    async toggleEventTag ({ commit }, { tag, eventId, isSelected, bookId }) {
      commit('toggleEventTag', { tag, eventId, isSelected })
      await plannerService.toggleTag({ tagId: tag.id, eventId, bookId })
    },

    async updateEventTag ({ commit }, { name, id, bookId }) {
      await plannerService.updateEventTag({ name, id, bookId })
      commit('updateEventTag', { name, id })
    },

    createEvent (_, data) {
      return plannerService.createEvent(data)
    },

    updateEvent (_, data) {
      return plannerService.update(data)
    },

    deleteEvent ({ commit }, { id, bookId }) {
      commit('toggleBookLoading', true)

      return plannerService.delete(id, bookId)
        .then(_ => {
          commit('toggleBookLoading', false)
          commit('deleteEvent', id)
        })
        .catch(() => commit('toggleBookLoading', false))
    },

    addRecurring ({ commit, dispatch }, { startDate, eventId, periodType, periodValue, lastWeekDate, bookId, bookIds }) {
      commit('toggleBookLoading', true)
      return plannerService.addRecurring({
        startDate: startDate,
        eventId: eventId,
        periodType: periodType,
        periodValue: periodValue,
        bookId
      })
        .then(_ => {
          commit('toggleBookLoading', false)
          dispatch('getUpcomingEvents', { startDate: lastWeekDate, limit: 50, bookIds })
        })
        .catch(() => commit('toggleBookLoading', false))
    },

    deleteRecurring ({ commit, dispatch }, { id, startDate, eventId, isAll, isFuture, lastWeekDate, bookId, bookIds }) {
      commit('toggleBookLoading', true)
      return plannerService.deleteRecurring({
        startDate: startDate,
        eventId: eventId,
        isAll: isAll,
        isFuture: isFuture,
        bookId
      })
        .then(_ => {
          commit('toggleBookLoading', false)
          commit('deleteEvent', id)
          dispatch('getUpcomingEvents', { startDate: lastWeekDate, limit: 50, bookIds })
        })
        .catch(() => commit('toggleBookLoading', false))
    },

    updateRecurring ({ commit, dispatch }, { isAll, isFuture, eventId, startDate, periodValue, periodType, id, lastWeekDate, firstWeekDate, bookId, bookIds }) {
      commit('toggleBookLoading', true)

      return plannerService.updateRecurring({
        periodValue: periodValue,
        periodType: periodType,
        startDate: startDate,
        isFuture: isFuture,
        eventId: eventId,
        isAll: isAll,
        bookId,
        id: id
      })
        .then(_ => {
          commit('toggleBookLoading', false)
          dispatch('getEventsByDate', { startDate: firstWeekDate, finishDate: lastWeekDate, bookIds })
          dispatch('getUpcomingEvents', { startDate: lastWeekDate, limit: 50, bookIds })
        })
        .catch(() => commit('toggleBookLoading', false))
    },

    getUpcomingEvents ({ commit }, { startDate, limit, bookIds }) {
      return plannerService.getUpcoming({ startDate, limit, bookIds })
        .then(({ data }) => {
          commit('setUpcomingEvents', data.events)
        })
    }
  }
}
